export default function ListIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 12.935}
      height={height ? height : width ? width : 12.935}
      viewBox="0 0 12.935 12.935"
      aria-hidden="true"
    >
      <path
        fill="currentColor"
        id="list_alt_FILL0_wght500_GRAD0_opsz48"
        d="M6.9,18.635a1.239,1.239,0,0,1-1.2-1.2V6.9a1.143,1.143,0,0,1,.362-.848A1.166,1.166,0,0,1,6.9,5.7H17.433a1.207,1.207,0,0,1,1.2,1.2V17.433a1.166,1.166,0,0,1-.353.839,1.143,1.143,0,0,1-.848.362Zm0-1.2H17.433V6.9H6.9V17.433Zm2.085-1.855a.544.544,0,1,0-.371-.159A.509.509,0,0,0,8.987,15.578Zm0-2.88a.544.544,0,1,0-.371-.159A.509.509,0,0,0,8.987,12.7Zm0-2.88a.544.544,0,1,0-.371-.159A.509.509,0,0,0,8.987,9.817Zm2.863,5.76H15.1a.5.5,0,0,0,.38-.159.523.523,0,0,0,.15-.371.514.514,0,0,0-.53-.53H11.849a.53.53,0,1,0,0,1.06Zm0-2.88H15.1a.53.53,0,1,0,0-1.06H11.849a.53.53,0,1,0,0,1.06Zm0-2.88H15.1a.53.53,0,1,0,0-1.06H11.849a.5.5,0,0,0-.38.159.523.523,0,0,0-.15.371.514.514,0,0,0,.53.53ZM6.9,17.433v0Z"
        transform="translate(-5.7 -5.7)"
      />
    </svg>
  );
}
